import { render } from "./ExpensesView.vue?vue&type=template&id=1136632a"
import script from "./ExpensesView.vue?vue&type=script&lang=js"
export * from "./ExpensesView.vue?vue&type=script&lang=js"

import "./ExpensesView.vue?vue&type=style&index=0&id=1136632a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__